'use strict';

exports.__esModule = true;

var _libphonenumberJs = require('libphonenumber-js');

exports.default = {
  getMessage: function getMessage(field) {
    return 'The ' + field + ' field must be a valid phone number.';
  },
  validate: function validate(val) {
    return (0, _libphonenumberJs.isValidNumber)(val);
  }
};